import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getFentraProfiles = api(async function fentraProfiles() {
    return await query(
        gql`
            query fentraProfiles {
                fentraProfiles {
                    _id
                    name
                    hasBearer
                    scimBaseUrl
                    ssoCallbackUrl
                    ssoLoginUrl
                    ssoMetadataUrl
                    spEntityId
                    groupPrefix
                }
            }
        `,
        {},
        { returns: "fentraProfiles" }
    )
})
